import { gql } from '@apollo/client';

const JOIN_BUNDLE = gql`
  mutation JoinBundle($fields: JoinBundleInput!) {
    joinBundle(fields: $fields)
  }
`;

export default JOIN_BUNDLE;
